import { render } from "./SidebarContent.vue?vue&type=template&id=11753675&ts=true"
import script from "./SidebarContent.vue?vue&type=script&lang=ts"
export * from "./SidebarContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__